import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMentorshipParticipantsByWorkspaceIdQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['Int']['input'];
}>;


export type GetMentorshipParticipantsByWorkspaceIdQuery = { __typename?: 'query_root', workspaceUsers: Array<{ __typename?: 'workspaceUsers', id: number, workspaceId: number, userId: string, user: { __typename?: 'users', id: string, fullName?: string | null, email: string, profilePhotoLink?: string | null, mentorEnabled?: boolean | null, menteeEnabled?: boolean | null, workspaceLocationId?: number | null, specialtyId?: any | null, workspaceLocation?: { __typename?: 'workspaceLocations', id: number, name: string, abbreviation?: string | null } | null, userSpecialty?: { __typename?: 'specialties', id: any, name: string } | null, mentorshipsAsMentee: Array<{ __typename?: 'mentorship', id: any, createdAt?: any | null, mentorshipProgramId?: number | null, mentorId: string, menteeId: string, mentor?: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null } | null, mentee?: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null } | null, mentorshipProgramProgresses: Array<{ __typename?: 'mentorshipProgramProgress', id: number, mentorshipProgramModuleId: number, completed: boolean }> }>, mentorshipsAsMentor: Array<{ __typename?: 'mentorship', id: any, createdAt?: any | null, mentorshipProgramId?: number | null, mentorId: string, menteeId: string, mentor?: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null } | null, mentee?: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null } | null, mentorshipProgramProgresses: Array<{ __typename?: 'mentorshipProgramProgress', id: number, mentorshipProgramModuleId: number, completed: boolean }> }> } }> };


export const GetMentorshipParticipantsByWorkspaceIdDocument = gql`
    query getMentorshipParticipantsByWorkspaceId($workspaceId: Int!) {
  workspaceUsers(
    where: {_and: [{workspaceId: {_eq: $workspaceId}}, {user: {_or: [{mentorEnabled: {_eq: true}}, {menteeEnabled: {_eq: true}}]}}]}
  ) {
    id
    workspaceId
    userId
    user {
      id
      fullName
      email
      profilePhotoLink
      mentorEnabled
      menteeEnabled
      workspaceLocationId
      workspaceLocation {
        id
        name
        abbreviation
      }
      specialtyId
      userSpecialty {
        id
        name
      }
      mentorshipsAsMentee {
        id
        createdAt
        mentorshipProgramId
        mentorId
        mentor {
          id
          fullName
          profilePhotoLink
        }
        menteeId
        mentee {
          id
          fullName
          profilePhotoLink
        }
        mentorshipProgramProgresses {
          id
          mentorshipProgramModuleId
          completed
        }
      }
      mentorshipsAsMentor {
        id
        createdAt
        mentorshipProgramId
        mentorId
        mentor {
          id
          fullName
          profilePhotoLink
        }
        menteeId
        mentee {
          id
          fullName
          profilePhotoLink
        }
        mentorshipProgramProgresses {
          id
          mentorshipProgramModuleId
          completed
        }
      }
    }
  }
}
    `;

/**
 * __useGetMentorshipParticipantsByWorkspaceIdQuery__
 *
 * To run a query within a React component, call `useGetMentorshipParticipantsByWorkspaceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentorshipParticipantsByWorkspaceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentorshipParticipantsByWorkspaceIdQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetMentorshipParticipantsByWorkspaceIdQuery(baseOptions: Apollo.QueryHookOptions<GetMentorshipParticipantsByWorkspaceIdQuery, GetMentorshipParticipantsByWorkspaceIdQueryVariables> & ({ variables: GetMentorshipParticipantsByWorkspaceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMentorshipParticipantsByWorkspaceIdQuery, GetMentorshipParticipantsByWorkspaceIdQueryVariables>(GetMentorshipParticipantsByWorkspaceIdDocument, options);
      }
export function useGetMentorshipParticipantsByWorkspaceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMentorshipParticipantsByWorkspaceIdQuery, GetMentorshipParticipantsByWorkspaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMentorshipParticipantsByWorkspaceIdQuery, GetMentorshipParticipantsByWorkspaceIdQueryVariables>(GetMentorshipParticipantsByWorkspaceIdDocument, options);
        }
export function useGetMentorshipParticipantsByWorkspaceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMentorshipParticipantsByWorkspaceIdQuery, GetMentorshipParticipantsByWorkspaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMentorshipParticipantsByWorkspaceIdQuery, GetMentorshipParticipantsByWorkspaceIdQueryVariables>(GetMentorshipParticipantsByWorkspaceIdDocument, options);
        }
export type GetMentorshipParticipantsByWorkspaceIdQueryHookResult = ReturnType<typeof useGetMentorshipParticipantsByWorkspaceIdQuery>;
export type GetMentorshipParticipantsByWorkspaceIdLazyQueryHookResult = ReturnType<typeof useGetMentorshipParticipantsByWorkspaceIdLazyQuery>;
export type GetMentorshipParticipantsByWorkspaceIdSuspenseQueryHookResult = ReturnType<typeof useGetMentorshipParticipantsByWorkspaceIdSuspenseQuery>;
export type GetMentorshipParticipantsByWorkspaceIdQueryResult = Apollo.QueryResult<GetMentorshipParticipantsByWorkspaceIdQuery, GetMentorshipParticipantsByWorkspaceIdQueryVariables>;